import { TestOrganization } from './types';

// Individual organization definitions
export const localSandboxOrganization: TestOrganization = {
  highbondId: '223',
  name: 'Sandbox',
  urlPrefix: 'sandbox',
  id: '265f833f-f385-432b-b061-2bfcd9ab95f0',
  subdomain: 'sandbox',
};

export const authorizationTestOrganization: TestOrganization = {
  highbondId: '224',
  name: 'Authorization Testing',
  urlPrefix: 'authorization',
  id: '3841a210-43a0-490f-a22e-4e5b74ce698b',
  subdomain: 'authorization',
};

export const devSandboxOrganization: TestOrganization = {
  highbondId: '223',
  name: 'Sandbox',
  urlPrefix: 'sandbox',
  id: '09885be8-6d6e-4406-b6e0-bba2250d9906',
  subdomain: 'sandbox',
};

export const devSolarisMonitoringOrganization: TestOrganization = {
  highbondId: '1193',
  name: 'Solaris monitoring',
  urlPrefix: 'solaris-monitoring',
  id: 'b0fee654-026a-4290-aec0-839de387e32c',
  subdomain: 'solaris-monitoring',
};

export const devSouthAfricanOrganization: TestOrganization = {
  highbondId: '278',
  name: 'af-org',
  urlPrefix: 'af-org',
  id: '3589627e-723b-4a73-9588-09b1e3694cd0',
  subdomain: 'af-org',
};

export const stagingSolarisTestingOrganization: TestOrganization = {
  highbondId: '1001698',
  name: 'Solaris Testing',
  urlPrefix: 'solaris-testing',
  id: '4cc26e0b-0890-4a50-8b59-ef33c5c10fb1',
  subdomain: 'solaris-testing',
};

export const productionBudapestTestOrganization: TestOrganization = {
  highbondId: '36651',
  name: 'Budapest Test Org',
  urlPrefix: 'budapest-test-org',
  id: '4cc26e0b-0890-4a50-8b59-ef33c5c10fb2',
  subdomain: 'budapest-test-org',
};

export const productionIssueManagerValidationOrganization: TestOrganization = {
  highbondId: '43938',
  name: 'Issue Manager Validation Org',
  urlPrefix: 'issue-mgr-org',
  id: 'a3a5b56a-6a9d-4da8-935d-7ab6656cbce2',
  subdomain: 'issue-mgr-org',
};

// Environment-specific arrays for seeders
export const localIssueManagerTestOrganizations: TestOrganization[] = [
  localSandboxOrganization,
  authorizationTestOrganization,
];

export const devIssueManagerTestOrganizations: TestOrganization[] = [
  devSandboxOrganization,
  devSolarisMonitoringOrganization,
  devSouthAfricanOrganization,
  authorizationTestOrganization,
];
